/*
Single source of truth for what may be persisted from Vuex state into
localStorage.

KAN-39 originally put JWT in sessionStorage so a tab close ended the
session. XOL-144/145 introduced an HttpOnly `xolas_auth` cookie that the
SPA cannot read, so the XSS-mitigation rationale is now served by the
cookie. XOL-151 moved JWT to localStorage so new tabs auto-authenticate.
We still strip the `auth` slice here because `auth.js` is the single
source of truth for the localStorage write — we don't want a second,
vuex-persistedstate-driven copy of the same data drifting out of sync.

Used by:
  * vuex-persistedstate reducer (src/main.js)
  * saveStore() (src/main.js) — legacy imperative persister

Any new cross-tab-unsafe slice goes in STRIPPED_KEYS.
------------------------------------------------------------------------ */

export const STRIPPED_KEYS = ['auth']

export function stripSensitiveState (state) {
  const out = {}
  if (!state) {
    return out
  }
  for (const k in state) {
    if (!Object.prototype.hasOwnProperty.call(state, k)) {
      continue
    }
    if (STRIPPED_KEYS.indexOf(k) !== -1) {
      continue
    }
    out[k] = state[k]
  }
  return out
}

export default {
  STRIPPED_KEYS: STRIPPED_KEYS,
  stripSensitiveState: stripSensitiveState
}
